import React from 'react';
import { Typography } from '@mui/material';
import { WalletList } from '../components/WalletList';

export const WalletsPage: React.FC = () => {
    document.title = "Duitleh - Wallets";
    return (
        <>
            <Typography variant="h4" gutterBottom>
                My Wallets
            </Typography>
            <WalletList />
        </>
    );
};
